// App.js - WEB
import React, {PureComponent} from "react";
import {View, Text, Button, FlatList, TouchableOpacity, Linking, Platform, I18nManager} from "react-native";
import {connect, Provider} from "react-redux";
import store from "../../redux/store";
import {
    NavigationContainer,
    DarkTheme as NavigationDarkTheme,
} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';

import {enableScreens} from 'react-native-screens';
import SplashSatiaScreen, {
    serviceActionAccount,
    serviceActionSetConnectionInternetHotspot,
    serviceActionSetIsConnected,
    serviceActionSetToken,
    serviceActionSetUser,
    serviceActionSetUserPassWifi,
    serviceActionSetwifiConnectionStatus,
    serviceActionSetwifiIsEnabled,
    serviceActionTokenFirebase
} from "../../screens/satia/splash/action/ActionSplashSatiaScreen";
import AsyncStorage from '@react-native-community/async-storage';
import {typeExport} from "../../redux/store/type";
import {navigationRef} from "../../redux/NavigationService";
import {AsyngStorageClass} from "../../tools/AsyngStorageClass";
import wifi from "../../importCalss/wifi";
import {serviceActionSetConnectionType} from "../../screens/137/splash/action/ActionSplashGetAllData";
import NetInfo from "@react-native-community/netinfo" ;
import axios from "axios" ;
import HMLoading from "../../customviews/HMLoading";
import FirstHotSpotScreen from "../../screens/satia/hotspot/FirstHotSpotScreen";
// import LoginHotSpotScreen from "../../screens/satia/hotspot/LoginHotSpotScreen";
// import FirstHotSpot2Screen from "../../screens/satia/hotspot/FirstHotSpot2Screen";
// import {VpnClass} from "../../screens/test/VpnClass";
// import FirstHotSpot2Screen from "../../screens/satia/hotspot/FirstHotSpot2Screen";


enableScreens();

const theme = {
    ...NavigationDarkTheme,
    // ...PaperDarkTheme,
    colors: {
        ...NavigationDarkTheme.colors,
        // ...PaperDarkTheme.colors,
        background: '#f0f0f0',
        text: '#ffffff'
    }
};


const linking = {
    prefixes: [
        'https://app.example.com'
        /* your linking prefixes */
    ],
    config: {
        screens: {
            initialRouteName: 'SplashSatiaScreen',

            SplashSatiaScreen: 'splash',
            LoginStackScreen: 'login',
            ListAccountSatiaScreen: 'accounts',
            DrawerScreen: {

                path: 'drawer',
                screens: {
                    HomeStackScreen: {

                        path: 'home',
                        /*   screens: {
                               MainSatiaScreen: 'main',

                           }*/

                    }

                }

            },
            HelpSoftwareSatiaScreen_Root: {
                path: 'help_software_app',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            InformationSatiaScreen_Root: {
                path: 'r',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            ListServiceSatiaScreen_Root: {
                path: 'ListService',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            PaySatiaScreen_Root: {
                path: 'Pay',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            FactorServiceHistorySatiaScreen_Root: {
                path: 'print',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            /*

               DrawerScreen: {
                   path: 'drawer',
                   screens: {
                       HomeStackScreen: {
                           path: 'home',
                           screens: {

                               MainSatiaScreen: 'main',

                               ListServiceSatiaScreen:'services',


                               ListGigSatiaScreen: 'gigs',


                               PaySatiaScreen:  'pay',

                               ListMicroConsumptionSatiaScreen:  'internetUsage',

                               ContactUsScreen: 'contactUs',

                               TestConnectionScreen:  'testConnection',

                               ListHistoryTelephoneLineStatusSatiaScreen: 'lineStatus',
                               ListServiceHistorySatiaScreen:  'serviceHistory',
                               ListMessageSatiaScreen:'messages',
                               ListOnlineChargingHistorySatiaScreen:'chargingHistory',
                               ListMessageOperatorSatiaScreen:  'tickets',
                               ListQuestionAndAnswerSatiaScreen:'questions',
                               ChangeInformationSatiaScreen: 'changeInformation',
                               ProfileSatiaScreen: 'profile',
                               UploadDocumentSatiaScreen:  'upload',
                               ListAccountSatiaScreen:'accounts',
                               ShowListMicroConsumptionSatiaScreen:  'detailsInternetUsage',

                               SatiaScreen:  'satia',

                               ChartSatiaScreen: 'chart',
                               ShowMap:  'map',
                               WebViewScreen: 'web',


                               /!*



               <HomeStack.Screen name="WebViewScreen" component={WebViewScreen}/>
               *!/
                           }
                       },
                   }
               },*/

        }

    },

    // getStateFromPath: (path, options) => {
    //     // Return a state object here
    //     // You can also reuse the default logic by importing `getStateFromPath` from `@react-navigation/native`
    // },
    // getPathFromState(state, config) {
    //
    //     // Return a path string here
    //     // You can also reuse the default logic by importing `getPathFromState` from `@react-navigation/native`
    // },
};


const RootStack = createStackNavigator();


let token = null;

/*const storage = Platform.select({
    web: () => require("localforage"),
    android: () => require("@react-native-community/async-storage").default,
    ios: () => require("@react-native-community/async-storage").default
})();*/
class RouterHotspotSatia extends PureComponent {
    async componentWillMount() {

        token = await AsyngStorageClass.checkToken();
        store.dispatch(serviceActionSetToken(token));
        if (token) {
            let user = await AsyngStorageClass.getASyng(typeExport._USER);
            store.dispatch(serviceActionSetUser(user))

            let account = await AsyngStorageClass.getASyng("Account");
            store.dispatch(serviceActionAccount(account, 0));
        }


        let token_fb = await AsyncStorage.getItem('fcmToken');

        store.dispatch(serviceActionTokenFirebase(token_fb));


        // store.dispatch(serviceActionSetTypeLogin(typeExport._TypeLogin, t)


    }

    componentWillReceiveProps(props) {

    }

    async componentDidMount() {

        if (Platform.OS === "android") {
            let storage = await AsyngStorageClass.getASyng(typeExport._UserPassWifi);
            store.dispatch(serviceActionSetUserPassWifi(storage))
        }

        let Conn = false;

        const dispatchConnected = state => {
            let isConnected = state.isConnected
            // this.props.setIsConnected(isConnected);
            store.dispatch(serviceActionSetIsConnected(isConnected))
            store.dispatch(serviceActionSetConnectionType(state))

            if (Platform.OS === "android") {
                // wifi.isEnabled((isEnabled) => {
                //     console.log("requestLogin=>isEnabled1", isEnabled, state.type == "wifi")
                //     store.dispatch(serviceActionSetwifiIsEnabled(isEnabled))
                // })
                this.checkSatusWifi(state)

            }
            Conn = isConnected;

        }


        NetInfo.addEventListener(dispatchConnected);

    }

    checkSatusWifi(state) {

        wifi.isEnabled((isEnabled) => {
            console.log("requestLogin=>isEnabled", isEnabled)
            //store.dispatch(serviceActionSetwifiIsEnabled(isEnabled))
            store.dispatch(serviceActionSetwifiIsEnabled(state.type == "wifi"))


            console.log("**wifi service enabled");
            wifi.connectionStatus((isConnected) => {

                store.dispatch(serviceActionSetwifiConnectionStatus(isConnected))

                axios(
                    {
                        //    url: `http://h.1547.ir/login?username=091895610009&password=863265`,
                        //  url: `http://h.1547.ir/login?username=09189648119&password=13981398`,
                        url: `https://google.com`,
                        method: "GET",
                        timeout: 3000,
                        headers: {
                            'Content-Type': 'text/html',
                        },
                    })
                    .then(async response => {
                        console.log("response", response);
                        let data = response.data;

                        store.dispatch(serviceActionSetConnectionInternetHotspot((response && response.status === 200)))
                    })
                    .catch((e) => {
                        store.dispatch(serviceActionSetConnectionInternetHotspot(false))
                        this.setState({
                            isConnectionGoogle: false,
                            // wifiConnectionStatus: true,

                        })
                        console.log("errorrequestLogin", e);
                    })

            });

        });

    }

    render() {
        return (


            <View style={[{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0}]}>
                <React.Suspense fallback={<HMLoading/>}>

                    <NavigationContainer ref={navigationRef} theme={theme} linking={linking}>

                        <RootStack.Navigator headerMode="none" initialRouteName="FirstHotSpotScreen">
                            {/*<RootStack.Screen name="VpnClass2" component={Vpn2Class}/>*/}
                            {/*<RootStack.Screen name="VpnClass" component={VpnClass}/>*/}
                            <RootStack.Screen name="FirstHotSpotScreen" component={FirstHotSpotScreen}/>
                            {/*<RootStack.Screen name="FirstHotSpot2Screen" component={FirstHotSpot2Screen}/>*/}
                            {/*<RootStack.Screen name="LoginHotSpotScreen" component={LoginHotSpotScreen}/>*/}


                        </RootStack.Navigator>

                    </NavigationContainer>
                </React.Suspense>
            </View>

        );
    }
}

const mapStateToProps = state => ({
    token: state.reducerSplashSatiaScreen.token,
    resultsSatia: state.reducerSplashSatiaScreen.resultsSatia,
    results: state.reducerSplashSatiaScreen.results,
    user: state.reducerSplashSatiaScreen.user,
    Account: state.reducerSplashSatiaScreen.Account,

});

export default connect(
    mapStateToProps,
    {}
)(RouterHotspotSatia);
